import React from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import {
  SectionMessage,
  SectionMessageType,
} from '../SectionMessage/SectionMessage';
import Text from '../../Text/Text';
import { classes, st } from './BookForSomeoneElseBanner.st.css';
import { BookForSomeoneElseBannerDataHooks } from './dataHooks';

const BookForSomeoneElseBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();

  return (
    <SectionMessage
      type={SectionMessageType.Wired}
      withoutIcon
      className={st(classes.root, { isMobile })}
      notificationClassName={classes.notification}
      dataHook={BookForSomeoneElseBannerDataHooks.BANNER}
    >
      <Text tagName="p" className={classes.body}>
        {t('bookings.form.bookForSomeoneElse.banner.body')}
      </Text>
    </SectionMessage>
  );
};

export default BookForSomeoneElseBanner;
